module.exports = __webpack_public_path__ + "static/media/blank.b845bbda.webp";